export enum transferStatus {
  processing = "processing",
  queued = "queued",
  successful = "successful",
  failed = "failed",
  reversed = "reversed",
}
